export const environment = {
    production: false,
    authConfig: {
      apiUrl: 'https://gwcdmswpocwap01.azurewebsites.net/api/', // API endpoint for fetching data from backend
      clientId: '6c959ac5-c4bf-4779-8679-43c0d48ecb88',
      redirectUri: 'https://mscontroltower-dev.ey.com/',
      postLogoutRedirectUri: 'https://mscontroltower-dev.ey.com/logout', 
      scope: 'api://de4f6e99-2fba-490a-982a-615230c08089/user_impersonation',
      authority: 'https://login.microsoftonline.com/ey.com/',
      domain: 'ey.com',
      activeSessionTimeOutInSeconds: 1800, // 30 minutes
      activeSessionTimeOutWarningInSeconds: 60, // 1 minutes
      sessionExpiredRoutePath: '/session-expired',
      unAuthorizedRoutePath: '/unauthorized',
    },
  };
  